import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
// Based on http://gaearon.github.io/react-dnd/examples-sortable-simple.html
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragSource, DropTarget } from 'react-dnd';
var style = {
  cursor: 'move',
  // needs relative position to keep absolutely positioned content
  // (such as ScreenReaderContent) from blowing up the drag preview
  position: 'relative'
};
export var cardSource = {
  beginDrag: function beginDrag(props) {
    return {
      id: props.id,
      index: props.index
    };
  },
  endDrag: function endDrag(props, monitor) {
    var item = monitor.getItem();
    var dropResult = monitor.getDropResult();
    if (!dropResult && props.onDropOut) {
      props.onDropOut(item);
    }
  },
  isDragging: function isDragging(props, monitor) {
    return props.id === monitor.getItem().id;
  }
};
export var cardTarget = {
  hover: function hover(props, monitor) {
    var item = monitor.getItem();
    var dragIndex = item.index;
    var hoverIndex = props.index;

    // Don't replace items with themselves and with items without index
    if (dragIndex === void 0 || dragIndex === hoverIndex) {
      return;
    }

    // Don't move item if given an allowed target group,
    // and the drop target is not the allowed group
    var _item$id$split = item.id.split('_'),
      _item$id$split2 = _slicedToArray(_item$id$split, 2),
      id = _item$id$split2[0],
      takeId = _item$id$split2[1];
    if (props.id && takeId !== props.id.split('_')[1]) {
      return;
    }
    if (props.choices && !props.choices.hasOwnProperty(id)) {
      return;
    }
    props.moveCard(dragIndex, hoverIndex);
    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex; // eslint-disable-line no-param-reassign
  }
};
export var Card = /*#__PURE__*/function (_Component) {
  function Card() {
    _classCallCheck(this, Card);
    return _callSuper(this, Card, arguments);
  }
  _inherits(Card, _Component);
  return _createClass(Card, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isDragging = _this$props.isDragging,
        connectDragSource = _this$props.connectDragSource,
        connectDropTarget = _this$props.connectDropTarget,
        margin = _this$props.margin;
      var opacity = isDragging ? 0 : 1;
      return connectDragSource(connectDropTarget(/*#__PURE__*/React.createElement("div", {
        style: _objectSpread(_objectSpread({}, style), {}, {
          opacity: opacity,
          margin: margin
        })
      }, this.props.children)));
    }
  }]);
}(Component);
_defineProperty(Card, "propTypes", {
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  index: PropTypes.number,
  isDragging: PropTypes.bool.isRequired,
  id: PropTypes.any.isRequired,
  choices: PropTypes.object,
  moveCard: PropTypes.func,
  children: PropTypes.node,
  margin: PropTypes.string
});
_defineProperty(Card, "defaultProps", {
  index: void 0,
  choices: void 0,
  moveCard: void 0,
  children: void 0,
  margin: '0'
});
var SourceCard = DragSource('dnd', cardSource, function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
})(Card);
var TargetAndSourceCard = DropTarget('dnd', cardTarget, function (connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
})(SourceCard);
export default TargetAndSourceCard;